import { HttpParameterCodec } from '@angular/common/http';

/**
 * @class ParamEncoder
 * @implements HttpParameterCodec
 * @desc can be used to replace ng's regular HttpUrlEncodingCodec, which shows
 * a different behavior to js's native encodeURIComponent in some regards.
 * @see https://medium.com/better-programming/how-to-fix-angular-httpclient-not-escaping-url-parameters-ddce3f9b8746
 */
export class ParamEncoder implements HttpParameterCodec {
    public encodeKey(key: string): string {
        return encodeURIComponent(key);
    }
    public encodeValue(value: string): string {
        return encodeURIComponent(value);
    }
    public decodeKey(key: string): string {
        return decodeURIComponent(key);
    }
    public decodeValue(value: string): string {
        return decodeURIComponent(value);
    }
}
